import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import CryptoJS from "crypto-js";

// MUI components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Custom MD components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Assets
import bgImage from "assets/images/bg-sign-up-cover.jpeg";
import PageLayout from "examples/LayoutContainers/PageLayout";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import safeToast from "utils/safeToast";
import { API_ENDPOINTS } from "config/api";
import { encryptText, decryptText } from "config/encryption";

function Cover() {
  const [formData, setFormData] = useState({
    userName: "",
    password: "",
    recoveryKey: "",
  });

  const navigate = useNavigate();

  // Session Check on Mount
  useEffect(() => {
    const sessionData = localStorage.getItem("userSession");
    const sessionLoggedUserDetail = localStorage.getItem("UserLogDetails");

    if (!sessionData&& !sessionLoggedUserDetail) {
      safeToast.warn("No session found. Please verify your roll number.");
      //remove corrupted session
        localStorage.removeItem("userSession");
      localStorage.removeItem("UserLogDetails");
      // Redirect to BasicAuth
      navigate("/BasicAuth");
      return;
    }

    try {
      const decryptedUserDetails = decryptText(sessionData);
      const parsedUserDetails = JSON.parse(decryptedUserDetails);
      const usn = parsedUserDetails?.usn;

      if (usn && usn !== "NOT -Registered") {
        // User has already registered - optionally redirect
      } else {
        safeToast.warn("No record found. Redirecting to registration...");
        setTimeout(() => navigate("/authentication/sign-up"), 3000);
      }
      if(sessionData && sessionLoggedUserDetail) {
        // check RollAuth Details
        const decryptedUserDetails = decryptText(sessionData);
        const parsedUserDetails = JSON.parse(decryptedUserDetails);
        const usn = parsedUserDetails?.usn || "";
        //check LoggedUserDetails
        const decryptedLoggedUserDetails = decryptText(sessionLoggedUserDetail);
        const parsedLoggedUserDetails = JSON.parse(decryptedLoggedUserDetails);
        const lus = parsedLoggedUserDetails?.UserName || "";
        if (usn == lus) {
          safeToast.warn(" Already found Login. Redirecting to Dashboard...");
          setTimeout(() => {
            navigate("/Dashboard"); // or "/authentication/sign-up"
          }, 5000); // Delay of 3 seconds (3000 ms)
        }
      }
    } catch (error) {
      console.error("Session parsing failed:", error);
      safeToast.error("Invalid session. Please verify your roll number.");
      //remove corrupted session
      localStorage.removeItem("userSession");
      localStorage.removeItem("UserLogDetails");
      // Redirect to BasicAuth
      navigate("/BasicAuth");
    }
  }, [navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleReset = () => {
    setFormData({
      userName: "",
      password: "",
      recoveryKey: "",
    });
  };

  const handleSubmit = async (e) => {
    // debugger;
    e.preventDefault();

    try {
      const sessionData = localStorage.getItem("userSession");

      if (!sessionData) {
        safeToast.warn("No session found. Please verify your roll number.");
        navigate("/BasicAuth");
        return;
      }

      const decryptedUserDetails = decryptText(sessionData);
      const parsedUserDetails = JSON.parse(decryptedUserDetails);
      const studentId = parsedUserDetails?.asid;
      const createdUserId = parsedUserDetails?.asid;

      if (!studentId || !createdUserId) {
        safeToast.error("Invalid student data. Please verify your roll number.");
        navigate("/BasicAuth");
        return;
      }

      const encryptedPassword = encryptText(formData.password);

      const payload = {
        studentId,
        userName: formData.userName,
        password: encryptedPassword,
        recoveryKey: formData.recoveryKey,
        createdUserId,
      };

      const response = await axios.post(API_ENDPOINTS.AUTH.REGISTER, payload);

      safeToast.success("Account created successfully!,");
      setTimeout(() => {
        navigate("/BasicAuth");
      }, 5000);
    } catch (error) {
      console.error("Registration failed:", error);
      safeToast.error("Registration failed. Please try again.");
      navigate("/BasicAuth");
    }
  };

  return (
    <PageLayout>
      <ToastContainer />
      <Grid container sx={{ minHeight: "100vh" }}>
        {/* Left - Form */}
        <Grid
          item
          xs={12}
          md={6}
          sx={{ display: "flex", alignItems: "center", justifyContent: "center", p: 4 }}
        >
          <Card sx={{ width: "100%", maxWidth: 400, p: 3 }}>
            <MDBox
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
              p={3}
              textAlign="center"
              mb={3}
            >
              <MDTypography variant="h4" fontWeight="medium" color="white">
                Create Your Account
              </MDTypography>
              <MDTypography display="block" variant="button" color="white" mt={1}>
                Fill in your details to register
              </MDTypography>
            </MDBox>
            <form onSubmit={handleSubmit}>
              <MDBox mb={2}>
                <MDInput
                  type="text"
                  label="User Name"
                  name="userName"
                  value={formData.userName}
                  onChange={handleChange}
                  variant="standard"
                  fullWidth
                  required
                />
              </MDBox>
              <MDBox mb={2}>
                <MDInput
                  type="password"
                  label="Password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  variant="standard"
                  fullWidth
                  required
                />
              </MDBox>
              <MDBox mb={3}>
                <MDInput
                  type="text"
                  label="Recovery Key"
                  name="recoveryKey"
                  value={formData.recoveryKey}
                  onChange={handleChange}
                  variant="standard"
                  fullWidth
                  required
                />
              </MDBox>
              <MDBox display="flex" justifyContent="space-between" mb={3}>
                <MDButton variant="gradient" color="info" type="submit" fullWidth>
                  Create Account
                </MDButton>
                <MDBox ml={2} />
                <MDButton variant="outlined" color="secondary" type="button" onClick={handleReset} fullWidth>
                  Reset
                </MDButton>
              </MDBox>
              <MDBox textAlign="center">
                <MDTypography variant="button" color="text">
                  Back{" "}
                  <MDTypography
                    component={Link}
                    to="/BasicAuth"
                    variant="button"
                    color="info"
                    fontWeight="medium"
                    textGradient
                  >
                   Are you sure Back to BasicAuth?
                  </MDTypography>
                </MDTypography>
              </MDBox>
            </form>
          </Card>
        </Grid>

        {/* Right - Image */}
        <Grid
          item
          xs={false}
          md={6}
          sx={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
      </Grid>
    </PageLayout>
  );
}

export default Cover;
